/** Flatten one or more DOM NodeLists into a single array (avoids spread on NodeList under older TS targets). */
export function nodeListToArray<T extends Element>(...lists: NodeListOf<T>[]): T[] {
  return lists.reduce<T[]>((acc, list) => acc.concat(Array.from(list)), []);
}
